import $ from 'jquery';
import CustomEvent from 'custom-event';

const namespace = 'routedetector';
let currentInstance = null;

/**
 * @param {Class} storage
 * @param {Object} routeMap
 */
export default class RouteDetector {
  constructor(storage, routeMap) {
    if (currentInstance) {
      return currentInstance;
    }

    currentInstance = this; // eslint-disable-line
    this.storage = storage;
    this.routeMap = routeMap;

    $(document).ready(this.handleReady.bind(this));
  }

  handleReady() {
    const requestType = this.storage.get();

    if (!requestType) {
      return;
    }

    this.manageRequestType(requestType);
  }

  /**
   * @param {String} type
   */
  manageRequestType(type) {
    const key = this.routeMap[type];
    const currentRoute = $('body').data('route');
    const validRequest = key && key.includes(currentRoute);

    if (currentRoute === 'challenge') {
      return;
    }

    if (validRequest) {
      this.broadcast({type, currentRoute});
      this.storage.remove();
      return;
    }

    this.storage.remove();
  }

  /**
   * @param {Object} payload
   */
  broadcast(payload) {
    const event = new CustomEvent(`${namespace}:change`, {
      detail: payload,
      bubbles: true,
    });

    document.dispatchEvent(event);
  }
}
